import type { SavedItem } from '../../types/saved-items';
import type { SaveService } from './save';

import { Environment } from '../../../environments/environment';
import { AddQueryParams } from '../../utils/add-query-params';

export async function GetSavedItems(
  this: SaveService,
  type: 'listing' | 'listing-search' = 'listing',
  fields: string[] = ['itemId'],
): Promise<SavedItem[]> {
  if (!this.stateService.userToken()) {
    return [];
  }

  const _base = `${Environment.usersUrl}/saved-items`;
  const _url = AddQueryParams(_base, { fields, sort: 'id:desc', type });
  const _authorization = `Bearer ${this.stateService.userToken()}`;
  const _options: RequestInit = {
    headers: {
      Authorization: _authorization,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- This is the correct header name for content type.
      'Content-Type': 'application/json',
    },
  };

  const _fetchResult = await fetch(_url, _options);

  if (!_fetchResult.ok) {
    return [];
  }

  const _result = (await _fetchResult.json()) as SavedItem[] | undefined;

  if (!_result?.length) {
    return [];
  }

  // Set the saved listing IDs for quick lookup.
  return _result;
}
